import React, { useState } from 'react';
import collectionsData from '../../collections/collections.json';

export default function ApiCollections({ onRequestSelect }) {
  const [expandedFolders, setExpandedFolders] = useState({});

  const toggleFolder = (folderName) => {
    setExpandedFolders((prev) => ({
      ...prev,
      [folderName]: !prev[folderName],
    }));
  };

  const handleRequestClick = (request) => {
    onRequestSelect(request); // Pass the entire request object
  };

  return (
    <div className="w-1/6 bg-gradient-to-b from-gray-50 to-gray-100 h-screen overflow-y-auto border-r border-gray-200 shadow-sm">
      {collectionsData.collections.map((collection, index) => (
        <div key={index} className="mb-2">
          <h1 className="px-3 py-2 text-sm font-bold text-[#fdb814] bg-white/50 rounded-md mx-2 mb-1">{collection.name}</h1>
          {collection.folders.map((folder, folderIndex) => (
            <div key={folderIndex}>
              <button
                className="w-full text-left px-3 py-2 text-sm flex justify-between items-center hover:bg-white/70 rounded-md mx-2 transition-colors duration-200"
                onClick={() => toggleFolder(folder.name)}
              >
                <span>{folder.name}</span>
                <span className="text-xs">{expandedFolders[folder.name] ? '▼' : '▶'}</span>
              </button>
              {expandedFolders[folder.name] && (
                <ul className="pl-4">
                  {folder.requests.map((request, reqIndex) => (
                    <li
                      key={reqIndex}
                      className="px-3 py-1.5 text-xs hover:bg-white/80 cursor-pointer rounded-md mx-2 transition-colors duration-200"
                      onClick={() => handleRequestClick(request)}
                    >
                      <span className="font-semibold text-[#fdb814]">{request.method}</span> {request.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}